export const TOAST_LIFE_TIME_MS = 3200
export const DEFICIENCY_TOAST_LIFE_TIME_MS = 8000
export const toast = ref<ReturnType<typeof useToast>>()
export const toastErrorMessage = ref('')
